export function numberKRW(value: number) {
  const rounded = Math.round(Number.isFinite(value) ? value : 0);
  // Plain "원" suffix instead of Intl's "₩" currency symbol — the Won sign glyph
  // renders as a stray strike-through line when captured via html2canvas.
  return `${rounded.toLocaleString('ko-KR')}원`;
}

export function formatHours(value: number) {
  const rounded = Math.round((Number.isFinite(value) ? value : 0) * 10) / 10;
  return `${rounded.toLocaleString('ko-KR', { maximumFractionDigits: 1 })}시간`;
}
